import { useEffect, useState } from 'react'
import subsidiariesApi from 'services/api/subsidiaries'

const minPromoCodeCountToShowWarning = 300

function usePromoValidation(promoCode) {
  const [isWarningByPassed, setIsWarningByPassed] = useState(false)

  const [isRateCodeAlreadyInUse, setIsRateCodeAlreadyInUse] = useState()

  useEffect(() => {
    setIsWarningByPassed(false)
    setIsRateCodeAlreadyInUse(false)
  }, [promoCode])

  async function checkRateCodeUsage(promoCode) {
    const res = await subsidiariesApi.rateCodeUsage(promoCode)

    const { totalBooking, totalExposedBooking } = res

    if (
      totalBooking > minPromoCodeCountToShowWarning ||
      totalExposedBooking > minPromoCodeCountToShowWarning
    ) {
      setIsRateCodeAlreadyInUse(true)
      return { isRateCodeAlreadyInUse: true }
    } else {
      setIsRateCodeAlreadyInUse(false)
      return { isRateCodeAlreadyInUse: false }
    }
  }

  return {
    isWarningByPassed,
    setIsWarningByPassed,
    isRateCodeAlreadyInUse,
    checkRateCodeUsage
  }
}

export default usePromoValidation
